import { Component, OnInit, inject } from '@angular/core';
import { AuthService } from '@bn/auth/services';
import { AuthRoutes } from '@bn/auth';
import { AppRoutes } from '@bn/dashboard-core/enums';
import { AbstractLazyDirective } from '@bn/shared/entities/abstracts/abstract-lazy.directive';
import { LazyLoadDirective } from '@bn/web-ui';
import { NgStyle, AsyncPipe } from '@angular/common';
import { ButtonComponent } from '@bn/web-ui/button/button.component';

@Component({
  templateUrl: './change-user.page.html',
  styleUrls: ['./change-user.page.scss'],
  imports: [LazyLoadDirective, NgStyle, ButtonComponent, AsyncPipe],
})
export class ChangeUserPage extends AbstractLazyDirective implements OnInit {
  private readonly authService = inject(AuthService);

  private decodedInitialUrl?: string;
  public decodedUserFromQueryParams?: string;
  ngOnInit() {
    this.decodedUserFromQueryParams = decodeURIComponent(this.route.snapshot.queryParams.user);
    this.decodedInitialUrl = decodeURIComponent(this.route.snapshot.queryParams.continueNavigation);
  }
  public navigateToTargetPage() {
    if (!this.decodedInitialUrl) return;

    this.router.navigateByUrl(this.getOriginalUrlWithoutUserParam());
  }

  public logoutAndPrefillLoginData() {
    this.authService.logout(undefined, false);
    const targetUrl = `/${AppRoutes.Auth}/${AuthRoutes.Login}?user=${encodeURIComponent(
      this.route.snapshot.queryParams.user,
    )}&returnUrl=${encodeURIComponent(this.getOriginalUrlWithoutUserParam())}`;
    window.location.replace(targetUrl);
  }

  private getOriginalUrlWithoutUserParam() {
    if (!this.decodedInitialUrl) return '';

    const splitUrlString = this.decodedInitialUrl.split('?');
    const originalSearchParams = new URLSearchParams(splitUrlString[1]);
    originalSearchParams.delete('user');

    return `${splitUrlString[0]}?${originalSearchParams.toString()}`;
  }
}
